import { render, staticRenderFns } from "./addPtSession.vue?vue&type=template&id=918d6b9a&"
import script from "./addPtSession.vue?vue&type=script&lang=js&"
export * from "./addPtSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports